export default {
    name: "PublicProductItemCard",
    mixins: [],
    props: {
        product: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            ageList: {
                A: "Adult",
                P: "Puppy",
            },
            isReadMore: false,
        };
    },
    methods: {
        checkIfMultipleBrands(bundleProducts) {
            // Remove Null and Duplicate Brands in a single Product List.
            const brands = [...new Set(bundleProducts.map((item) => item.brand.name))];

            return {
                name: brands.length > 1 ? "MULTIPLE BRANDS" : brands[0],
                brands,
                isMultiple: brands.length > 1,
            };
        },
        getImage(product) {
            return product.productImg
                ? product.productImg
                : require("@/assets/images/product/dog-default-picture-color.png");
        },

        replaceWithImagePlaceholder(event) {
            event.target.src = require("@/assets/images/product/dog-default-picture-color.png");
        },

        showItemModal(product) {
            this.$emit("showItemModal", product);
        },

        showImageModal(product) {
            this.$swal({
                imageHeight: 250,
                imageUrl: this.getImage(product),
                imageAlt: "Image",
                title: product.name,
                text: product.description ? product.description : "",
            });
        },

        readMoreAndModal(product) {
            this.showImageModal(product);
        },

        stocksAvailable(stockQty) {
            return stockQty <= 0 || stockQty === null ? "Out of Stock" : `Available Qty: ${stockQty}`;
        },
    },
};
